export const getBatch = <T>(items: T[], batchSize: number, batchNumber: number): T[] => {
    const start = batchSize * (batchNumber - 1);
    const end = batchSize * batchNumber;

    if (items.length < end) {
        return items.slice(start);
    }

    return items.slice(start, end);
};
